window.trackgtag =function(){
    if(typeof window.gtag !== "function"){
        console.log('Google Tag Manager not present!')
    }else {
        gtag('event', 'conversion', {'send_to': 'AW-892645511/VqOuCOTHj-wBEIfh0qkD'});
    }
}
